<template>
  <div class="mnd-progress">
    <template v-for="step in stepcount" :key="step">
      <div class="mnd-progress__line" v-if="step > 1"></div>
      <div class="mnd-progress__circle" :class="{'active': step == currentstep}">{{ step }}</div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    stepcount: {type: Number, default: 1},
    currentstep: {type: Number, default: 1}
  }
}
</script>

<style lang="sass">
.mnd-progress
  margin: 0 auto
  padding: 32px 0
  display: flex
  align-items: center
  width: 100%
  max-width: 605px
  &__line
    background: colors.$moar_silver_for_the_god_of_silver
    height: 1px
    flex-grow: 1
    margin: 0 8px
  &__circle
    flex-shrink: 0
    color: white
    text-align: center
    display: flex
    align-items: center
    justify-content: center
    line-height: 1
    width: 48px
    height: 48px
    padding-top: 3px
    font-size: 20px
    background-color: colors.$moar_silver_for_the_god_of_silver2
    transition: background-color .3s ease-out
    border-radius: 48px
    &.active
      background-color: colors.$newred
      
</style>